enum CopilotPriority {
    None = 0,
    High = 1,
    Normal = 2,
    Low = 3,
}

export function isCopilotHighPriority(score: number | undefined | null): boolean {
    return getCopilotPrioritizePriority(score) === CopilotPriority.High;
}

export function isCopilotLowPriority(score: number | undefined | null): boolean {
    return getCopilotPrioritizePriority(score) === CopilotPriority.Low;
}

export function getCopilotPrioritizePriority(score: number | undefined | null): CopilotPriority {
    if (score === 4 || score === 5) {
        return CopilotPriority.High;
    } else if (score === 3) {
        return CopilotPriority.Normal;
    } else if (score === 1 || score === 2) {
        return CopilotPriority.Low;
    }

    return CopilotPriority.None;
}

/**
 * Maps a copilot inbox score to a priority group ordinal for sort comparisons.
 * Higher ordinal = higher priority group.
 * Scores: 4-5 = High (group 2), 3 = Normal (group 1), 1-2 = Low (group 0), else = None → Normal (group 1)
 */
export function getPriorityGroup(score: number | undefined | null): number {
    if (score === 4 || score === 5) {
        return 2; // High
    }
    if (score === 1 || score === 2) {
        return 0; // Low
    }
    return 1; // Normal (includes score 3, undefined, null, 0, -1)
}
